const CommunicationUtilKeys = {
  COMMS_TYPE: "Communication Type",
  COMMS_RECIPIENT: "Communication Recipient",
  COMMS_SUBJECT: "Message Subject",
  COMMS_CONTENT: "Message Content"
}

export default CommunicationUtilKeys
